<template>
  <div id="right-filter" class="activitytrackermenu right-dropdown dropdown-menu pull-left">
    <ul role="menu" v-on:click.stop>
      <li class="col-xs-12 column-name mb-5" v-for="cellVal in headers" :key="cellVal">
        <div class="col-xs-12 p-0" :class="{'tooltip-wrapper': mandatoryColumns && mandatoryColumns.includes(cellVal)}">
          <span class="tooltiptext" v-if="mandatoryColumns && mandatoryColumns.includes(cellVal)">Mandatory column</span>
          <div class="col-xs-1 p-0 activityTracker-checkbox">
            <span class="checkbox">
              <label>
                <input type="checkbox" :disabled="mandatoryColumns && mandatoryColumns.includes(cellVal)" :value="cellVal" v-model="userSelectableColumns" />
                <span class="cr">
                  <img class="select-check" src="/static/images/icons/select_check.svg" alt="">
                  <!-- <i class="cr-icon glyphicon glyphicon-ok"></i> -->
                </span>
              </label>
            </span>
          </div>
          <div class="col-xs-10 pl-8 pr-0">
            <span
              class="vertical-align-sub select-item"
              v-bind:class="{
                'font-bold': userSelectableColumns.indexOf(cellVal) > -1,
                'font-normal': userSelectableColumns.indexOf(cellVal) === -1
              }"
              >{{ cellVal }}</span
            >
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['headers', 'selectedColumns', 'mandatoryColumns'],
  data() {
    return {
      userSelectableColumns: [],
      triggerWatchInitially: false,
    };
  },
  watch: {
    selectedColumns: {
      handler() {
        if (this.selectedColumns.length) {
          this.triggerWatchInitially = true;
          this.userSelectableColumns = [...this.selectedColumns];
        }
      },
      immediate: true,
    },

    userSelectableColumns: {
      handler(newVal, oldValue) {
        if (this.userSelectableColumns.length && !this.triggerWatchInitially) {
          if (this.userSelectableColumns.length > 6) {
            this.$nextTick(() => {
              this.userSelectableColumns.splice(6, this.userSelectableColumns.length);
            });
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: 'Limit',
              text: 'Max 6 columns can be added.',
              group: 'custom-notification',
            });
          }
          if (this.userSelectableColumns.length < 3) {
            const text = 'Table should have Min 3 columns.';
            this.$nextTick(() => {
              this.userSelectableColumns = [...oldValue];
            });
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: 'Limit',
              text,
              group: 'custom-notification',
            });
          }
          this.$emit('setSelectedColumns', this.userSelectableColumns);
        }
        this.triggerWatchInitially = false;
      },
      immediate: true,
    },
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      const returnVal = value.replace(/_/g, ' ').toString();
      return returnVal
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    },
  },

  methods: {
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
  },
};
</script>

<style scoped>
.activitytrackermenu.dropdown-menu.pull-left {
  right: -6px;
  top: 36px;
  left: unset;
  min-width: 180px;
}

.select-item {
  color: #3E3E3E;
  font-size: 12px;
  font-weight: 600;
  line-height: 23px;
}

img.select-check {
  height: 11px;
  width: 11px !important;
}

.activityTracker-checkbox {
  line-height: 23px;
}

.activityTracker-checkbox > .checkbox .cr {
  width: 15px;
  height: 15px;
}

.pl-8 {
  padding-left: 8px;
}

.right-dropdown {
  background: #ffffff;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  /* padding: 10px; */
}

.dropdown-menu {
  border: none;
  padding: 0px 5px 0px 0px;
  margin: 0px;
}

.activitytrackermenu.dropdown-menu.pull-left {
  right: -6px;
  top: 36px;
  left: unset;
  min-width: 180px;
}

#right-filter.activitytrackermenu.dropdown-menu.pull-left {
  right: -10px;
  top: 35px;
  left: unset;
  width: 250px;
}

.font-normal {
  font-weight: normal !important;
}

ul {
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 0px;
  max-height: 400px;
  width: 240px;
  overflow: auto;
  scrollbar-width: thin;
}

/* ul:hover {
  overflow: auto;
} */

::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-thumb {
  background: #CDCDCD;
  border-radius: 20px;
}
::-webkit-scrollbar-thumb:hover {
  /* background: gray; */
  background: #CDCDCD;
}

#right-filter .column-name {
  padding-left: 15px;
  padding-right: 10px;
  padding-top: 5px;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-wrapper .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip-wrapper .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}
.tooltip-wrapper:hover .tooltiptext {
  visibility: visible;
}
</style>
